<script lang="ts">
  import Header from '$components/landing/Header.svelte';
  import Hero from '$components/landing/Hero.svelte';
  import EcosystemRibbon from '$components/landing/EcosystemRibbon.svelte';
  import Problem from '$components/landing/Problem.svelte';
  import Innovations from '$components/landing/Innovations.svelte';
  import Level0 from '$components/landing/Level0.svelte';
  import Compare from '$components/landing/Compare.svelte';
  import FAQ from '$components/landing/FAQ.svelte';
  import FinalCTA from '$components/landing/FinalCTA.svelte';
  import Footer from '$components/landing/Footer.svelte';
</script>

<svelte:head>
  <title>VuAuth — Codes that come to you.</title>
  <meta
    name="description"
    content="VuAuth — TOTP authenticator that respects the clock. Codes that come to you. Mathematically incapable of leaving your device."
  />
</svelte:head>

<Header />
<main id="top">
  <Hero />
  <EcosystemRibbon />
  <Problem />
  <Innovations />
  <Level0 />
  <Compare />
  <FAQ />
  <FinalCTA />
</main>
<Footer />
